import * as React from 'react';

import './ButtonGroup.scss';

var ButtonGroup = function ButtonGroup(_ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        isDisabled = _ref.isDisabled;
    return React.createElement(
        'div',
        {
            className: 'btn-group ' + className + ' ' + (isDisabled ? 'is-disabled' : '')
        },
        children
    );
};

ButtonGroup.propTypes = {
    /** A group of buttons */
    children: PropTypes.node.isRequired,

    /** Class name for ButtonGroup */
    className: PropTypes.string,
    isDisabled: PropTypes.bool
};
export default ButtonGroup;
import PropTypes from 'prop-types';